import React from "react";
import styes from "./st.module.scss";

import img1 from "./images/image.webp";
import HeaderCompusWithImage from "../../../../Common/HeaderCompusWithImage/HeaderCompusWithImage";
import LeftColoredTitle from "../../../../components/Titles/LeftColoredTitle";

export const PolitiqueInstitutionnelleHeader = () => {
  return (
    <HeaderCompusWithImage
      images={[img1]}
      title="Politique institutionnelle de l'UIK"
    />
  );
};

function PolitiqueInstitutionnelle() {
  return (
    <div className={styes.main}>
      <LeftColoredTitle>Politique institutionnelle de l'UIK</LeftColoredTitle>

      <br />
      <br />

      <p className={styes.description}>
        <strong className="color-main">►</strong> S’inscrit pleinement dans sa
        mission et sa vision en assurant la cohérence entre ses valeurs
        fondamentales et ses orientations stratégiques à long terme.
      </p>

      <p className={styes.description}>
        <strong className="color-main">► </strong>Est appropriée à son contexte
        spécifique en tenant compte des besoins de ses parties prenantes, de son
        environnement socio-économique, culturel et scientifique, ainsi que des
        évolutions nationales et internationales de l’enseignement supérieur.
      </p>

      <p className={styes.description}>
        <strong className="color-main">► </strong>Fournit un cadre structurant
        pour l’établissement, la révision et l’évaluation des objectifs
        institutionnels, favorisant ainsi une planification stratégique claire
        et partagée.
      </p>

      <p className={styes.description}>
        <strong className="color-main">► </strong>Inclut un engagement formel à
        satisfaire toutes les exigences légales, réglementaires et normatives
        applicables, garantissant la conformité et la transparence des activités
        pédagogiques, administratives et de recherche.
      </p>

      <p className={styes.description}>
        <strong className="color-main">► </strong>Repose sur un engagement
        continu en faveur de l’amélioration permanente de son système de
        Management (SMOE) à travers une démarche participative impliquant
        l’ensemble des acteurs (étudiants, enseignants, personnels
        administratifs) et une évaluation régulière des processus et résultats.
      </p>

      <p className={styes.description}>
        <strong className="color-main">► </strong>Prend en compte les évolutions
        pédagogiques, didactiques, scientifiques et techniques pertinentes, en
        intégrant les innovations éducatives, les avancées de la recherche et
        les nouvelles technologies, afin d’assurer la pertinence et l’excellence
        des formations proposées.
      </p>

      <p className={styes.description}>
        <strong className="color-main">► </strong>Intègre un engagement fort
        envers la responsabilité sociétale de l’organisme, en promouvant
        l’inclusion, la diversité, l’égalité des chances, la durabilité
        environnementale et en favorisant l’ancrage territorial et l’ouverture
        sur les enjeux économiques, sociaux et culturels contemporains.
      </p>

      <p className={styes.description}>
        <strong className="color-main">► </strong>Décrit et inclut un engagement
        clair en faveur de la gestion rigoureuse et éthique de la propriété
        intellectuelle, assurant la protection juridique, la valorisation et la
        diffusion des résultats de la recherche, tout en respectant les
        traditions académiques et la mission de service public de l’organisme.
      </p>
    </div>
  );
}

export default PolitiqueInstitutionnelle;
